import React from 'react'
import { useMutation } from '@apollo/client'
import fetchProjects from '../queries/project-list'
import duplicateProject from '../mutations/duplicate-project'
import deleteProject from '../mutations/delete-project'
import debounce from 'debounce'

function ProjectActions(props) {
  const [duplicateProjectMutation] = useMutation(duplicateProject)
  const [deleteProjectMutation] = useMutation(deleteProject)

  const duplicateThisProject = debounce((e) => {
    const { id, toggleOpen } = props
    duplicateProjectMutation({
      variables: { id },
      refetchQueries: [{ query: fetchProjects }],
    }).then(() => {
      toggleOpen(e)
    })
  }, 500)

  const deleteThisProject = debounce(() => {
    const { id } = props
    deleteProjectMutation({
      variables: { id },
      refetchQueries: [{ query: fetchProjects }],
    })
  }, 500)
  const triggerRename = (e) => {
    const { toggleRename, toggleOpen } = props
    toggleOpen(e)
    toggleRename(e)
  }
  const { toggleOpen, isOpen, canDelete } = props
  const classes = isOpen ? 'project-actions active' : 'project-actions'

  return (
    <div className="more-trigger" onClick={toggleOpen}>
      <i className="material-icons">more_horiz</i>
      <div className={isOpen ? 'overlay no-shadow' : ''} onClick={toggleOpen} />
      <div className={classes} onClick={(e) => e.stopPropagation()}>
        <div className="actions-close-div" onClick={toggleOpen}>
          <i className="material-icons actions-close-trigger">more_horiz</i>
        </div>
        <div className="action-div" onClick={duplicateThisProject}>
          <i className="material-icons">content_copy</i>
          Duplicate
        </div>
        <hr />
        <div className="action-div" onClick={triggerRename}>
          <i className="material-icons">create</i>
          Rename
        </div>
        {canDelete && <hr />}
        {canDelete && (
          <div className="action-div" onClick={deleteThisProject}>
            <i className="material-icons">delete</i>
            Delete
          </div>
        )}
      </div>
    </div>
  )
}

export default ProjectActions
